const isProduction = process.env.NODE_ENV === 'production';

// URLs para producción (Cloudflare Pages)
export const DATA_URLS = {
  csv: '/productos.csv',
  getImageUrl: (codigo) => `/images/${codigo}.webp`,
};

// URLs para desarrollo local (React dev server)
export const LOCAL_DATA_URLS = {
  csv: process.env.PUBLIC_URL + '/productos.csv',
  getImageUrl: (codigo) => process.env.PUBLIC_URL + `/images/${codigo}.webp`,
};

export const getDataConfig = () => {
  if (isProduction) {
    return DATA_URLS;
  }
  return LOCAL_DATA_URLS;
};